module.exports = __webpack_public_path__ + "img/slogn_bg_m.f8bfa485.jpg";